import React from "react";
import styles from "../styles/ServiceCard.module.css";

const ServiceCard = ({ title, description, stats, technologies }) => {
  return (
    <div className={styles.card}>
      <div className={styles.iconContainer}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="#182CD4"
            strokeWidth="2"
          ></path>
        </svg>
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
      <div className={styles.statsContainer}>
        {stats.map((stat, index) => (
          <div key={index} className={styles.stat}>
            <div className={styles.statNumber}>{stat.number}</div>
            <div className={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>
      <div className={styles.technologiesContainer}>
        {technologies.map((tech, index) => (
          <div key={index} className={styles.technology}>
            {tech}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceCard;
